<template>
	<div class="reading" v-if="isTypeFalls">
		<div class="date" :title="datetimeFormatted"><time :datetime="datetimeFormatted">{{ value.datetime | timeAgo(vue) }}</time></div>
		<div class="ok">
			<span :class="classBool(value.values.ok)">{{ printBool(value.values.ok) }}</span>
		</div>
		<div class="sos">
			<span :class="classBool(value.values.sos)">{{ printBool(value.values.sos) }}</span>
		</div>
		<div class="false_positive">
			<span :class="classBool(value.values.false_positive)">{{ printBool(value.values.false_positive) }}</span>
		</div>
		<div class="no_response">
			<span :class="classBool(value.values.no_response)">{{ printBool(value.values.no_response) }}</span>
		</div>
		<div><button-icon-loading @click.native.stop="btnViewClick" icon="go to"/></div>
	</div>
	<div class="reading" v-else>
		<div class="value">{{ last }} <span v-html="units"></span></div>
		<div class="date" :title="datetimeFormatted"><time :datetime="datetimeFormatted">{{ value.datetime | timeAgo(vue) }}</time></div>
		<div><button-icon-loading @click.native.stop="btnViewClick" icon="go to"/></div>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'value',
		'units'
	],
	data () {
		return {
			vue: this
		}
	},
	computed: {
		datetimeFormatted () {
			return this.$options.filters.formatDateTime(this.value.datetime, this)
		},
		last () {
			switch (this.value.type_id) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `${this.value.values.systolic_last} ${this.value.values.diastolic_last}`
				case Readings.TYPE_CALORIES:
				case Readings.TYPE_PEDOMETER:
					return this.value.values.value
				case Readings.TYPE_GEOFENCING:
					return `${this.value.values.latitude.toFixed(2)} ${this.value.values.longitude.toFixed(2)}`
				default:
					return this.value.values.last
			}
		},
		isTypeFalls () {
			return this.value.type_id === Readings.TYPE_FALLS
		}
	},
	methods: {
		classBool (value) {
			return value ? 'true' : 'false'
		},
		printBool (value) {
			return value ? '✓' : 'ꭙ'
		},
		btnViewClick () {
			this.$root.$emit('biometric-details-highlight-latest-reading', this.value)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/rows/ReadingsWidgetLatestRow.vue